// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71bd74b9","667":"948b4a85"}[chunkId] + ".chunk.js";
};